<template>
  <AdminLayout>
    <template #breadcrumb>
      <breadcrumb-link view="AdminPayerList" label="Payers" />
      <breadcrumb-link view="AdminPayerMerge" label="Merge Payers" :active="true" />
    </template>

    <div class="box" style="position: relative">
      <b-loading :is-full-page="false" v-model="loading"></b-loading>
      <!-- Merge Form -->
      <div class="columns">
        <!-- A Payers -->
        <div class="column">
          <div class="card">
            <div class="card-header">
              <p class="card-header-title">
                A Payers
                <span class="tag is-info is-rounded ml-2">{{ aPayers.length }}</span>
              </p>
              <div class="card-header-icon">
                <b-input
                  v-model="aSearch"
                  placeholder="Search name..."
                  size="is-small"
                  icon="magnify"
                ></b-input>
              </div>
            </div>
            <div class="card-content table-container">
              <b-table
                :data="filteredAPayers"
                :selected.sync="selectedAPayer"
                hoverable
                striped
                detailed
                detail-key="id"
                :show-detail-icon="true"
                @click="handleASelect"
                height="400"
              >
                <b-table-column field="name" label="Name" sortable v-slot="props">
                  {{ props.row.name }}
                  <small v-if="props.row.name !== props.row.name_internal">
                    <br />
                    [{{ props.row.name_internal }}]
                  </small>
                </b-table-column>

                <b-table-column
                  field="code"
                  label="Code"
                  sortable
                  v-slot="props"
                  class="code-column"
                >
                  <div class="code-wrapper">{{ props.row.code }}</div>
                </b-table-column>

                <b-table-column field="is_active" label="Status" v-slot="props">
                  <b-tag
                    :type="
                      props.row.is_active && props.row.is_available ? 'is-success' : 'is-danger'
                    "
                  >
                    {{ props.row.is_active && props.row.is_available ? 'Active' : 'Inactive' }}
                  </b-tag>
                </b-table-column>

                <template #detail="props">
                  <div class="content">
                    <p>
                      <strong>ID:</strong>
                      {{ props.row.id }}
                      <br />
                      <strong>Name:</strong>
                      {{ props.row.name }}
                      <br />
                      <strong>A Name :</strong>
                      {{ props.row.name_internal }}
                      <br />
                      <strong>A Code:</strong>
                      {{ props.row.code }}
                      <br />
                      <strong>A Is Available:</strong>
                      {{ props.row.is_available ? 'Yes' : 'No' }}
                      <br />
                      <strong>A Is Active:</strong>
                      {{ props.row.is_active ? 'Yes' : 'No' }}
                      <br />
                      <strong>Blue:</strong>
                      {{ props.row.is_blue ? 'Yes' : 'No' }}
                      <br />
                      <strong>Is Group:</strong>
                      {{ props.row.is_group ? 'Yes' : 'No' }}
                      <br />
                      <strong>Split Service Type:</strong>
                      {{ props.row.split_service_type ? 'Yes' : 'No' }}
                      <br />
                      <strong>Payer Group ID:</strong>
                      {{ props.row.payer_group_id }}
                      <br />
                    </p>
                  </div>
                </template>
              </b-table>
            </div>
          </div>
        </div>

        <!-- P Payers -->
        <div class="column">
          <div class="card">
            <div class="card-header">
              <p class="card-header-title">
                p Payers
                <span class="tag is-info is-rounded ml-2">{{ pPayers.length }}</span>
              </p>
              <div class="card-header-icon">
                <b-input
                  v-model="pSearch"
                  placeholder="Search name..."
                  size="is-small"
                  icon="magnify"
                ></b-input>
              </div>
            </div>
            <div class="card-content table-container">
              <b-table
                :data="filteredPPayers"
                :selected.sync="selectedPPayer"
                hoverable
                striped
                detailed
                detail-key="id"
                :show-detail-icon="true"
                @click="handlePSelect"
                height="400"
              >
                <b-table-column field="p_name" label="Name" sortable v-slot="props">
                  {{ props.row.p_name }}
                </b-table-column>

                <b-table-column
                  field="p_code"
                  label="Code"
                  sortable
                  v-slot="props"
                  class="code-column"
                >
                  <div class="code-wrapper">{{ props.row.p_code }}</div>
                </b-table-column>

                <b-table-column field="p_is_active" label="Status" v-slot="props">
                  <b-tag
                    :type="
                      props.row.p_is_active && props.row.p_is_available ? 'is-success' : 'is-danger'
                    "
                  >
                    {{ props.row.p_is_active && props.row.p_is_available ? 'Active' : 'Inactive' }}
                  </b-tag>
                </b-table-column>

                <template #detail="props">
                  <div class="content">
                    <p>
                      <strong>ID:</strong>
                      {{ props.row.id }}
                      <br />
                      <strong>Name:</strong>
                      {{ props.row.name }}
                      <br />
                      <strong>P Name:</strong>
                      {{ props.row.p_name }}
                      <br />
                      <strong>P Code:</strong>
                      {{ props.row.p_code }}
                      <br />
                      <strong>P Is Active:</strong>
                      {{ props.row.p_is_active ? 'Yes' : 'No' }}
                      <br />
                      <strong>P Is Available:</strong>
                      {{ props.row.p_is_available ? 'Yes' : 'No' }}
                      <br />
                      <strong>Is Group:</strong>
                      {{ props.row.is_group ? 'Yes' : 'No' }}
                      <br />
                      <strong>Payer Group ID:</strong>
                      {{ props.row.payer_group_id }}
                      <br />
                    </p>
                  </div>
                </template>
              </b-table>
            </div>
          </div>
        </div>
      </div>

      <!-- Merge Action -->
      <div class="block">
        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label">Merged Name</label>
          </div>
          <div class="field-body">
            <div class="field">
              <p class="control">
                <b-input v-model="mergedName" placeholder="Enter name for merged payer"></b-input>
              </p>
            </div>
            <div class="field">
              <div class="control">
                <b-field>
                  <b-radio v-model="mergeSourceOrder" native-value="p_first">P first</b-radio>
                  <b-radio v-model="mergeSourceOrder" native-value="a_first" class="ml-3">
                    A first
                  </b-radio>
                </b-field>
              </div>
            </div>
            <div class="field">
              <p class="control">
                <b-button
                  type="is-primary"
                  :disabled="!canMerge"
                  @click="handleMerge"
                  :loading="merging"
                >
                  Merge Payers
                </b-button>
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- Merged Payers List -->
      <div class="block" v-if="mergedPayers.length">
        <div class="card">
          <div class="card-header">
            <p class="card-header-title">
              Merged Payers
              <span class="tag is-info is-rounded ml-2">{{ mergedPayers.length }}</span>
            </p>
            <div class="card-header-icon">
              <b-input
                v-model="mergedSearch"
                placeholder="Search name..."
                size="is-small"
                icon="magnify"
              ></b-input>
            </div>
          </div>
          <div class="card-content">
            <b-table
              :data="filteredMergedPayers"
              hoverable
              striped
              detailed
              detail-key="id"
              :show-detail-icon="true"
            >
              <b-table-column field="name" label="Name" sortable v-slot="props">
                {{ props.row.name }}
              </b-table-column>
              <b-table-column field="is_active" label="A Active" sortable v-slot="props">
                <b-switch type="is-success" @input="handleActiveSwitch('is_active', $event, props.row.id)"
                  :value="props.row.is_active" :disabled="indexClicked === props.row.id" />
              </b-table-column>

              <b-table-column field="p_is_active" label="P Active" sortable v-slot="props">
                <b-switch type="is-success" @input="handleActiveSwitch('p_is_active', $event, props.row.id)"
                  :value="props.row.p_is_active" :disabled="indexClicked === props.row.id" />
              </b-table-column>

              <b-table-column field="code" label="A Code" sortable v-slot="props">
                {{ props.row.code }}
              </b-table-column>

              <b-table-column field="p_code" label="P Code" sortable v-slot="props">
                {{ props.row.p_code }}
              </b-table-column>

              <b-table-column field="actions" label="Actions" centered v-slot="props">
                <b-button
                  size="is-small"
                  type="is-info"
                  icon-left="call-split"
                  @click="handleSplit(props.row)"
                  :loading="props.row.splitting"
                >
                  Split
                </b-button>
              </b-table-column>
              <template #detail="props">
                <div class="content">
                  <p>
                    <strong>ID:</strong>
                    {{ props.row.id }}
                    <br />
                    <strong>Name:</strong>
                    {{ props.row.name }}
                    <br />
                    <strong>A Name :</strong>
                    {{ props.row.name_internal }}
                    <br />
                    <strong>A Code:</strong>
                    {{ props.row.code }}
                    <br />
                    <strong>A Is Available:</strong>
                    {{ props.row.is_available ? 'Yes' : 'No' }}
                    <br />
                    <strong>A Is Active:</strong>
                    {{ props.row.is_active ? 'Yes' : 'No' }}
                    <br />
                    <strong>P Name:</strong>
                    {{ props.row.p_name }}
                    <br />
                    <strong>P Code:</strong>
                    {{ props.row.p_code }}
                    <br />
                    <strong>P Is Active:</strong>
                    {{ props.row.p_is_active ? 'Yes' : 'No' }}
                    <br />
                    <strong>P Is Available:</strong>
                    {{ props.row.p_is_available ? 'Yes' : 'No' }}
                    <br />
                    <strong>Blue:</strong>
                    {{ props.row.is_blue ? 'Yes' : 'No' }}
                    <br />
                    <strong>Is Group:</strong>
                    {{ props.row.is_group ? 'Yes' : 'No' }}
                    <br />
                    <strong>Split Service Type:</strong>
                    {{ props.row.split_service_type ? 'Yes' : 'No' }}
                    <br />
                    <strong>Payer Group ID:</strong>
                    {{ props.row.payer_group_id }}
                    <br />
                  </p>
                </div>
              </template>
            </b-table>
          </div>
        </div>
      </div>
    </div>
  </AdminLayout>
</template>

<script>
import request from '../../request';
import AdminLayout from '../../layouts/AdminLayout.vue';

export default {
  name: 'AdminPayerMerge',
  components: {
    AdminLayout,
  },
  data() {
    return {
      loading: true,
      merging: false,
      aPayers: [],
      pPayers: [],
      mergedPayers: [],
      selectedAPayer: null,
      selectedPPayer: null,
      indexClicked: null,
      mergedName: '',
      mergeSourceOrder: 'p_first',
      mergedColumns: [
        {
          field: 'name',
          label: 'Name',
          sortable: true,
        },
        {
          field: 'code',
          label: 'A Code',
          sortable: true,
        },
        {
          field: 'p_code',
          label: 'p Code',
          sortable: true,
        },
        {
          field: 'actions',
          label: 'Actions',
          centered: true,
          customRenderer: true,
        },
      ],
      aSearch: '',
      pSearch: '',
      mergedSearch: '',
    };
  },
  computed: {
    canMerge() {
      return this.selectedAPayer && this.selectedPPayer && this.mergedName.trim() !== '';
    },
    filteredAPayers() {
      if (!this.aSearch) return this.aPayers;
      const search = this.aSearch.toLowerCase();
      return this.aPayers.filter((payer) => payer.name.toLowerCase().includes(search));
    },
    filteredPPayers() {
      if (!this.pSearch) return this.pPayers;
      const search = this.pSearch.toLowerCase();
      return this.pPayers.filter((payer) => payer.p_name.toLowerCase().includes(search));
    },
    filteredMergedPayers() {
      if (!this.mergedSearch) return this.mergedPayers;
      const search = this.mergedSearch.toLowerCase();
      return this.mergedPayers.filter((payer) => payer.name.toLowerCase().includes(search));
    },
  },
  created() {
    this.loading = true;
    request
      .get('/admin/payers')
      .then((resp) => {
        // Filter payers into A and p lists
        this.aPayers = resp.data.payers.filter((p) => p.code && !p.p_code && !p.payer_group_id);
        this.pPayers = resp.data.payers.filter((p) => p.p_code && !p.code && !p.payer_group_id);
        this.mergedPayers = resp.data.payers.filter((p) => p.code && p.p_code);
      })
      .finally(() => (this.loading = false));
  },
  methods: {
    handleMerge() {
      if (!this.canMerge) return;

      this.merging = true;
      request
        .post('/admin/payers/merge', {
          a_payer_id: this.selectedAPayer.id,
          p_payer_id: this.selectedPPayer.id,
          name: this.mergedName,
          source_order: this.mergeSourceOrder,
        })
        .then((resp) => {
          // Add the new merged payer to the list
          this.mergedPayers.unshift(resp.data.payer);

          // Remove the merged payers from their respective lists
          this.aPayers = this.aPayers.filter((p) => p.id !== this.selectedAPayer.id);
          this.pPayers = this.pPayers.filter((p) => p.id !== this.selectedPPayer.id);

          // Reset selections
          this.selectedAPayer = null;
          this.selectedPPayer = null;
          this.mergedName = '';

          this.$buefy.toast.open({
            message: 'Payers merged successfully!',
            type: 'is-success',
          });
        })
        .catch((error) => {
          this.$buefy.toast.open({
            message: error.response?.data?.message || 'Failed to merge payers',
            type: 'is-danger',
          });
        })
        .finally(() => {
          this.merging = false;
        });
    },
    handleASelect(row) {
      if (this.selectedAPayer && this.selectedAPayer.id === row.id) {
        this.selectedAPayer = null;
      }
    },
    handlePSelect(row) {
      if (this.selectedPPayer && this.selectedPPayer.id === row.id) {
        this.selectedPPayer = null;
      }
    },
    handleSplit(payer) {
      this.$set(payer, 'splitting', true);
      request
        .post('/admin/payers/split', {
          payer_id: payer.id,
        })
        .then((resp) => {
          // Add the split payers back to their respective lists
          this.aPayers.unshift(...resp.data.children.filter((p) => p.code && !p.p_code));
          this.pPayers.unshift(...resp.data.children.filter((p) => p.p_code && !p.code));

          // Remove the merged payer from the list
          this.mergedPayers = this.mergedPayers.filter((p) => p.id !== payer.id);

          this.$buefy.toast.open({
            message: 'Payer split successfully!',
            type: 'is-success',
          });
        })
        .catch((error) => {
          this.$buefy.toast.open({
            message: error.response?.data?.message || 'Failed to split payer',
            type: 'is-danger',
          });
        })
        .finally(() => {
          this.$set(payer, 'splitting', false);
        });
    },
    handleActiveSwitch(field, isActive, id) {
      this.indexClicked = id;
      const payload = { [field]: isActive };
      request
        .put(`/admin/payers/${id}`, payload)
        .finally(() => (this.indexClicked = null));
    },
  },
};
</script>

<style scoped>
/* Add specific styling for code columns coze they are long without spacing which breaks the layout */
.code-column {
  width: 150px !important;
}

.code-wrapper {
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: break-all;
  hyphens: auto;
  max-width: 150px;
}

.card {
  box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1);
  margin-bottom: 1.5rem;
}

.card-header {
  display: flex;
  align-items: center;
  padding: 0.5rem 0.75rem;
}

.card-header-title {
  display: flex;
  align-items: center;
}

.tag {
  font-size: 0.85rem;
  font-weight: normal;
}

.ml-2 {
  margin-left: 0.5rem;
}

.card-content {
  padding: 1rem;
}

.card-header-icon {
  padding: 0;
  margin-left: auto;
}

.card-header-icon .input {
  width: 200px;
}

.table-container {
  padding: 0.75rem;
}

/* table header fixed */
.table-container >>> .table-wrapper {
  overflow: auto;
}

/* table height fixed */
.table-container >>> .table {
  margin-bottom: 0;
}

.table-container >>> .table-wrapper::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.table-container >>> .table-wrapper::-webkit-scrollbar-thumb {
  background-color: #dbdbdb;
  border-radius: 4px;
}

.table-container >>> .table-wrapper::-webkit-scrollbar-track {
  background-color: transparent;
}
</style>
